import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography, TextField } from '@material-ui/core';

import useStyles from './useStyles';

const Search = props => {
  const { values, onChange } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Typography variant="h2">{t('components.AdminDashboard.Search.searchBy')}</Typography>
      <Typography variant="body1">{t('components.AdminDashboard.Search.searchDescription')}</Typography>
      <div className={classes.searchFields}>
        <TextField
          variant="outlined"
          id="name"
          name="name"
          placeholder={t('components.AdminDashboard.Search.loanOfficerNameFieldPlaceholder')}
          onChange={onChange}
          value={values.name}
          className={classes.field}
        />
        <TextField
          variant="outlined"
          id="company"
          name="company"
          placeholder={t('components.AdminDashboard.Search.companyFieldPlaceholder')}
          onChange={onChange}
          value={values.company}
          className={classes.field}
        />
        <TextField
          variant="outlined"
          id="companyNmls"
          name="companyNmls"
          placeholder={t('components.AdminDashboard.Search.companyNmlsFieldPlaceholder')}
          onChange={onChange}
          value={values.companyNmls}
          className={classes.field}
        />
      </div>
    </Box>
  );
};

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape().isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/Search/Search.js